import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Button } from '../../../components';
import styles from './styles.module.scss';
import Picture from '../../../components/Picture/Picture';

const cx = classNames.bind(styles);

const UseApp = ({ url, setChosenView }) => (
  <div className={cx('useApp')}>
    <div className={cx('headerChoice')}>See Volo in...</div>
    <div className={cx('choices')}>
      <div className={cx('appChoice', 'row')}>
        <div className="col-6">
          <Picture
            className="d-inline-block"
            src="https://rivall-public.s3-us-west-1.amazonaws.com/home-page/app-icon.png"
            alt="app icon"
          />
          <span>Volo App</span>
        </div>
        <div className="col-6">
          <Button primary>
            <a href={url} target="_blank" rel="noopener noreferrer">
              Download
            </a>
          </Button>
        </div>
      </div>
      <div className={cx('appChoice', 'row')}>
        <div className="col-6">
          <Picture
            className="d-inline-block"
            src="https://rivall-public.s3-us-west-1.amazonaws.com/home-page/browser.jpeg"
            alt="app icon"
          />
          <span>Browser</span>
        </div>
        <div className="col-6">
          <Button onClick={() => setChosenView('browser')}>Continue</Button>
        </div>
      </div>
    </div>
  </div>
);

UseApp.propTypes = {
  url: PropTypes.string.isRequired,
  setChosenView: PropTypes.func.isRequired,
};

export default UseApp;
